import React, {Component} from 'react';
import Helmet from 'react-helmet';
import PropTypes from 'prop-types';

import LogoText from '../../media/svg/logo-twineeds.svg';

import './LoginLayout.scss';

export default class LoginLayout extends Component {
  static propTypes = {
    helmet: PropTypes.element,
  };

  static defaultProps = {
    helmet: null,
  };

  render() {
    const {helmet} = this.props

    const title = "Twineeds | Consultants Ingénierie, Achats, Supply, Finance";
    const description = "Twineeds connecte entreprises et consultants indépendants en ingénierie, achats, supply, finance ou RH, avec un haut niveau d’expertise pour chaque mission.";

    return (
      <div className="login-layout d-flex align-items-center">
        <Helmet>
          <title>{helmet.title || title}</title>
          <meta name="description" content={helmet.description || description}/>
          <meta property="og:title" content={helmet.title || title}/>
          <meta property="og:description" content={helmet.description || description}/>
          <meta property="twitter:title" content={helmet.title || title}/>
          <meta property="twitter:description" content={helmet.description || description}/>
        </Helmet>
        
        <div className="row align-items-center">
          <div className="col-10 p-4 p-md-5">
            <div className="logo mb-4">
              <LogoText/>
            </div>
            {this.props.children}
          </div>
        </div>
        <div className="d-none d-xl-block"/>
      </div>
    );
  }
}
